import MenuBookIcon from '@mui/icons-material/MenuBook';

import PageShow from "./PageShow";
import PageList from "./PageList";
import PageEdit from "./PageEdit";
import PageCreate from "./PageCreate";

const PageResourceProps = {
    name: "page",
    list: PageList,
    edit: PageEdit,
    create: PageCreate,
    show: PageShow,
};

export const PageMenuProps = {
    to: "/page",
    primaryText: "Page",
    icon: MenuBookIcon,
};

export default PageResourceProps;
